import {showRangeScale} from "../form/showRangeScale";
import {uploadFile} from "../form/uploadFile";
import {setPrice} from "../form/setPrice";
import {toggleModalForm} from "../helpers/toggleModalForm";
import {toggleFormMobileAnimation} from "../form/toggleFormMobileAnimation";

export function initFormModal() {
    const   service = document.getElementById('form-modal-service'),
            fileModal = document.getElementById('formModalUpload');

    const btnResetModal = document.querySelector('.modal-form .btn-reset'),
        btnApplyModal = document.querySelector('.modal-form .btn-apply'),
        btnRangeModal = document.querySelector('.modal-form .btn-range'),
        btnBackModal = document.querySelector('.modal-form .btn-skip');

    const rangeScaleModal = document.querySelector('.modal-form .range__scale'),
        rangeScaleModalBtn = document.querySelectorAll('.modal-form input[name="price"]');

    $( "#form-modal-service" ).selectmenu({
        open: function (event, ui) {
            toggleFormMobileAnimation(false);
        },
        close: function (event, ui) {
            toggleFormMobileAnimation(true);
        }
    });

    $( "#modal-range-mobile" ).selectmenu({
        open: function (event, ui) {
            service.nextElementSibling.classList.toggle('selectmenu-open-mobile');
        },
        close: function (event, ui) {
            service.nextElementSibling.classList.remove('selectmenu-open-mobile');
        }
    });

    btnBackModal.addEventListener('click', toggleModalForm);

    btnRangeModal.addEventListener('click', function (evt) {
        showRangeScale(evt, fileModal)
    });

    btnResetModal.addEventListener('click', function (evt) {
        uploadFile(evt, fileModal, btnResetModal)
    });

    fileModal.addEventListener('change', function (evt) {
        uploadFile(evt, fileModal, btnResetModal)
    })

    btnApplyModal.addEventListener('click', function (evt) {
        setPrice(evt, fileModal, rangeScaleModalBtn, rangeScaleModal, btnRangeModal)
    });
}
